import { render, staticRenderFns } from "./serviceNursing.vue?vue&type=template&id=1027e582&scoped=true&"
import script from "./serviceNursing.vue?vue&type=script&lang=js&"
export * from "./serviceNursing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1027e582",
  null
  
)

export default component.exports